export function Footer() {
  const handleNewsletterSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const formData = new FormData(form);
    
    try {
      const response = await fetch('https://readdy.ai/api/form/d6pummk4k19g20dvr140', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: new URLSearchParams(formData as any).toString(),
      });

      if (response.ok) {
        alert('Thank you for subscribing!');
        form.reset();
      } else {
        alert('Something went wrong. Please try again.');
      }
    } catch (error) {
      alert('Something went wrong. Please try again.');
    }
  };

  return (
    <footer className="bg-gradient-to-b from-[#0A0A0A] to-black border-t border-[#1A1A1A] py-16">
      <div className="max-w-[1400px] mx-auto px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12">
          {/* Brand Column */}
          <div className="md:col-span-1">
            <div className="flex items-center gap-3 mb-4">
              <div className="w-10 h-10 bg-gradient-to-br from-[#D4AF37] to-[#B8941F] rounded-lg flex items-center justify-center">
                <i className="ri-book-open-line text-black text-xl"></i>
              </div>
              <div className="text-white font-bold text-lg">
                Daily Nest<br />Publishing
              </div>
            </div>
            <p className="text-[#666666] text-sm leading-relaxed">
              Helping authors, experts, and entrepreneurs publish professionally and build lasting authority.
            </p>
          </div>

          {/* Navigation Links */}
          <div>
            <h3 className="text-white font-semibold mb-4">Navigation</h3>
            <ul className="space-y-3">
              <li>
                <a href="#services" className="text-[#999999] hover:text-[#D4AF37] transition-colors text-sm cursor-pointer">
                  Services
                </a>
              </li>
              <li>
                <a href="#packages" className="text-[#999999] hover:text-[#D4AF37] transition-colors text-sm cursor-pointer">
                  Packages
                </a>
              </li>
              <li>
                <a href="#process" className="text-[#999999] hover:text-[#D4AF37] transition-colors text-sm cursor-pointer">
                  Process
                </a>
              </li>
              <li>
                <a href="#faq" className="text-[#999999] hover:text-[#D4AF37] transition-colors text-sm cursor-pointer">
                  FAQ
                </a>
              </li>
              <li>
                <a href="#contact-section" className="text-[#999999] hover:text-[#D4AF37] transition-colors text-sm cursor-pointer">
                  Contact
                </a>
              </li>
            </ul>
          </div>

          {/* Contact Column */}
          <div>
            <h3 className="text-white font-semibold mb-4">Contact</h3>
            <ul className="space-y-3">
              <li className="flex items-start gap-2">
                <i className="ri-map-pin-line text-[#D4AF37] mt-0.5"></i>
                <span className="text-[#999999] text-sm leading-relaxed">
                  C/O Daily Nest Group LLC<br />
                  1302 Waugh Dr. #413<br />
                  Houston, TX
                </span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-phone-line text-[#D4AF37]"></i>
                <a href="tel:+13466169099" className="text-[#999999] hover:text-[#D4AF37] transition-colors text-sm cursor-pointer">
                  (346) 616-9099
                </a>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-mail-line text-[#D4AF37]"></i>
                <a href="mailto:support@shopdailynest.com" className="text-[#999999] hover:text-[#D4AF37] transition-colors text-sm cursor-pointer">
                  support@shopdailynest.com
                </a>
              </li>
            </ul>
          </div>

          {/* Newsletter Column */}
          <div>
            <h3 className="text-white font-semibold mb-4">Stay Updated</h3>
            <p className="text-[#666666] text-sm mb-4">
              Get publishing tips and author insights delivered to your inbox.
            </p>
            <form className="flex gap-2" data-readdy-form id="newsletter-footer" onSubmit={handleNewsletterSubmit}>
              <input
                type="email"
                name="email"
                placeholder="Your email"
                className="flex-1 bg-[#1A1A1A] border border-[#2A2A2A] text-white px-4 py-2 rounded-lg text-sm focus:outline-none focus:border-[#D4AF37] transition-colors"
                required
              />
              <button
                type="submit"
                className="bg-[#D4AF37] text-black px-5 py-2 rounded-lg text-sm font-semibold hover:brightness-110 transition-all whitespace-nowrap cursor-pointer"
              >
                Subscribe
              </button>
            </form>
          </div>
        </div>

        {/* Social Media & Copyright */}
        <div className="border-t border-[#1A1A1A] pt-8 flex flex-col md:flex-row justify-between items-center gap-6">
          <div className="text-[#666666] text-sm">
            © {new Date().getFullYear()} Daily Nest Publishing. All rights reserved.
          </div>

          <div className="flex items-center gap-5">
            <a
              href="https://facebook.com"
              target="_blank"
              rel="noopener noreferrer nofollow"
              className="w-9 h-9 bg-[#1A1A1A] rounded-full flex items-center justify-center text-[#999999] hover:bg-[#D4AF37] hover:text-black transition-all cursor-pointer"
            >
              <i className="ri-facebook-fill text-lg"></i>
            </a>
            <a
              href="https://twitter.com"
              target="_blank"
              rel="noopener noreferrer nofollow"
              className="w-9 h-9 bg-[#1A1A1A] rounded-full flex items-center justify-center text-[#999999] hover:bg-[#D4AF37] hover:text-black transition-all cursor-pointer"
            >
              <i className="ri-twitter-x-line text-lg"></i>
            </a>
            <a
              href="https://instagram.com"
              target="_blank"
              rel="noopener noreferrer nofollow"
              className="w-9 h-9 bg-[#1A1A1A] rounded-full flex items-center justify-center text-[#999999] hover:bg-[#D4AF37] hover:text-black transition-all cursor-pointer"
            >
              <i className="ri-instagram-line text-lg"></i>
            </a>
            <a
              href="https://linkedin.com"
              target="_blank"
              rel="noopener noreferrer nofollow"
              className="w-9 h-9 bg-[#1A1A1A] rounded-full flex items-center justify-center text-[#999999] hover:bg-[#D4AF37] hover:text-black transition-all cursor-pointer"
            >
              <i className="ri-linkedin-fill text-lg"></i>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
